<script>
import { upload } from "@/api/account";
import { Toast } from 'vant';

export default {
  data() {
    return {
      localIds: [], // 选定照片的本地ID列表数组
      upLoadImgFlag: false, // 判断图片是否正在上传
      uploadImageIndex: 0, // 上传图片的index
      upLoadImgList: [], // 上传图片的服务器地址
    }
  },
  methods: {
    // 选择图片
    uploadImage(size, showLoading) {
      let imgList = [];
      this.uploadImageIndex = 0
      wx.chooseImage({
        count: size || 1, // 默认9
        sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
        success: res => {
          this.upLoadImgFlag = true;
          this.localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          // 显示上传成功弹窗
          if (showLoading) {
            Toast.loading({
              message: '上传了' + this.localIds.length + '张图片',
              mask: true
            });
          }
          this.uploadToServer()
        },
        fail: err => {
          this.upLoadImgFlag = false;
        },
        cancel: res => {
          this.upLoadImgFlag = false;
        }
      })
    },
    // 上传图片到服务器
    uploadToServer() {
      if (this.uploadImageIndex >= this.localIds.length) {
        this.upLoadImgFlag = false;
        return;
      }
      wx.uploadImage({
        localId: this.localIds[this.uploadImageIndex], // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        complete: async r => {
          if (r.serverId) {
            let media_id = r.serverId; // 返回图片的服务器端ID
            try {
              const uploadRes = await upload({ media_id });
              this.upLoadImgList.push(uploadRes.data.link);
              this.addImgToDom && this.addImgToDom(uploadRes.data.link)
              this.setAvatar && this.setAvatar(uploadRes.data.link)
            } catch (error) {
              Toast(error.message)
              this.upLoadImgFlag = false;
              console.log('上传图片失败');
            }
          }
          setTimeout(() => {
            this.uploadImageIndex = this.uploadImageIndex + 1;
            this.uploadToServer()
          }, 10);
        }
      });
    },
  }
}
</script>
